import { TogglesState } from '../state/toggles';

type Plans = 'infinity' | 'max' | 'invest' | 'standard';

type Toggles = {
  enableCorePriceChange: TogglesState['enableCorePriceChange'];
  enableGSRChange: TogglesState['enableGSRChange'];
};

export interface PlanPrices {
  infinity: number;
  max: number;
  invest: number;
  standard: number;
  select: number
}

export function priceDeltas(ft?: Toggles): Record<Plans, number> {
  const deltas: Record<Plans, number> = {
    infinity: 9.99,
    max: 4.99,
    invest: 3.99,
    standard: 0
  };

  if (ft?.enableCorePriceChange?.enabled) {
    return {
      infinity: 8.99,
      max: 3.99,
      invest: 2.99,
      standard: 0
    };
  }

  return deltas;
}

export function planPrices(ft?: Toggles): PlanPrices {
  const prices = {
    infinity: 14.98,
    max: 9.98,
    invest: 8.98,
    standard: 4.99,
    select: 4.99
  };

  if (ft?.enableCorePriceChange?.enabled) {
    prices.standard = 5.99;
    prices.select = 5.75
  }

  return prices;
}

export interface SavingsRewards {
  core: string;
  max: string;
}

export function savingsRewards(
  ft?: Pick<Toggles, 'enableGSRChange'>
): SavingsRewards {
  if (ft?.enableGSRChange?.enabled) {
    return {
      core: '2%',
      max: '3%'
    };
  }
  return {
    core: '1%',
    max: '2%'
  };
}
